import { createListQueryFn, DocumentAssetsApi } from "@xs2event/js-lib/api";

const documentAssetsApi = new DocumentAssetsApi();

export const useDocumentAssets = createListQueryFn(documentAssetsApi, "documentassetslistGet");